import StartAnswerSearch from './start_answer_search';

export default class SetSortType {
  constructor(context) {
    this.context = context;
  }

  run({ type }) {
    const answerPanel = this.context.stores.answerPanel.get();
    answerPanel.setSortType(type);
    this.context.stores.answerPanel.set(answerPanel);

    this.context.executeAction(StartAnswerSearch);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/answers/set_sort_type.js